//Estilos
import './FilterScreen.css'
import {SEARCH_FILTRO} from '../../constants/colors';
// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBars
} from "@fortawesome/free-solid-svg-icons";

/* 
    Componente de icono flotante de "=" que funciona como "filtros".
        Donde verFiltro recibe el componente dialog a mostrar.
*/
function FilterScreen({verFiltro}) {
    return (
        <div className='filter-container add-filter' onClick={() => verFiltro(true)}>
            <FontAwesomeIcon icon={faBars} className='add-filter-cont' style={{color: SEARCH_FILTRO }}/>
            <div className="input-filter-txt">Filtros</div>
        </div>
    );
}

export default FilterScreen